import React, { useState } from "react";
import { postsIds } from "../../../../constants/app";
import { isEmpty } from "lodash";
import moment from "moment";
import { formatNumberWithSpaces, parseNumToFixed, roundToFixed } from "../../../../utils/common";

export default function ResultTable({ period, staffData, dataRevenues, normalShift, getPercentStaff, getPrizeRevenueStaff, revenueRatio, percentsPosts, stylesTable, colWidths, columnsCount, startOfMonthDate, calculateTotal, weekendsDaysIndexes, openPrizesColumns, isNotNumber }) {
    const [selectedTable, setSelectedTable] = useState('sum');
    
    const getRenderTotal = (data) => {
        if (!data ) return 0;
        if (!isNotNumber(data.result)) return data.result;
        return data.plan || 0;
    }

    const getStaffTotal = (staffs, type) => {
        if (isEmpty(staffs)) return 0;

        return staffs.reduce((total, staff) => {
            if (!staff || (isEmpty(staff.revenues) && isEmpty(staff.prize))) return total;

            const totalHours = calculateTotal(staff.revenues)

            const getPrize = (type) => {
                if (!staff || isEmpty(staff.prize)) return 0;
                const start = moment(startOfMonthDate);
                let minDate, maxDate;
    
                if (type === 'first') {
                    minDate = start.clone().startOf('day');
                    maxDate = start.clone().add(14, 'days').endOf('day');
                } else {
                    minDate = start.clone().add(15, 'days').startOf('day');
                    maxDate = start.clone().endOf('month');
                }
    
                return staff.prize.reduce((acc, prize) => {
                    if (prize.isDeleted) return acc;
                    const prizeDate = moment(prize.date, 'YYYY-MM-DD');
                    if (prizeDate.isBetween(minDate, maxDate, 'days', '[]')) {
                        if (prize.type === 'prize') return acc + (prize.sum || 0);
                        return acc - (prize.sum || 0);
                    }
                    return acc;
                }, 0);
            };

            const getPercent = (type) => {
                if (!staff || isEmpty(staff.revenues)) return 0;
    
                const percent = !isEmpty(percentsPosts) ? percentsPosts[String(staff.postId)] || 0 : 0;
                if (percent === 0) return 0;
    
                const start = moment(startOfMonthDate);
                let minDate, maxDate;
    
                if (type === 'first') {
                    minDate = start.clone().startOf('day');
                    maxDate = start.clone().add(14, 'days').endOf('day');
                } else {
                    minDate = start.clone().add(15, 'days').startOf('day');
                    maxDate = start.clone().endOf('month');
                }
    
                return staff.revenues.reduce((acc, revenue, index) => {
                    const currentDate = moment(start).add(index, 'days');
                    if (currentDate.isBetween(minDate, maxDate, 'days', '[]')) {
                        const postStaffsWork = (staffs || []).filter((entityStaff) => {
                            if (entityStaff.id === staff.id) return false;
                            if (isEmpty(entityStaff.revenues[index])) return false;
                            if (!isNotNumber(entityStaff.revenues[index].sum.result) || !isNotNumber(entityStaff.revenues[index].sum.plan)) return true;
                            return false;
                        });
    
                        const postStaffsHours = (postStaffsWork || []).reduce((acc, entityStaff) => {
                            if (!isNotNumber(entityStaff.revenues[index].sum.result)) return acc += +entityStaff.revenues[index].sum.result;
                            if (!isNotNumber(entityStaff.revenues[index].sum.plan)) return acc += +entityStaff.revenues[index].sum.plan;
                            return acc;
                        }, 0);
    
                        const hours = !isNotNumber(revenue.sum.result) ? revenue.sum.result : revenue.sum.plan || 0;
    
                        const allHours = +postStaffsHours + +hours;
    
                        const dataDate = dataRevenues[index] || 0;
                        const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
    
                        const allPercent = roundToFixed(revenueDate * (percent / 100));
                        const hourPercent = roundToFixed(allPercent / allHours);
                        
                        if (hours > 0 && revenueDate > 0 && hourPercent > 0) return acc += roundToFixed(hourPercent * hours) || 0;
                    }
                    return acc;
                }, 0);
            }
    
            const getRevenuePrize = (type) => {
                if (!staff || isEmpty(staff.revenues)) return 0;
    
                const start = moment(startOfMonthDate);
                let minDate, maxDate;
    
                if (type === 'first') {
                    minDate = start.clone().startOf('day');
                    maxDate = start.clone().add(14, 'days').endOf('day');
                } else {
                    minDate = start.clone().add(15, 'days').startOf('day');
                    maxDate = start.clone().endOf('month');
                }
    
                const result = staff.revenues.reduce((acc, revenue, index) => {
                    const currentDate = moment(start).add(index, 'days');
                    if (currentDate.isBetween(minDate, maxDate, 'days', '[]')) {
                        const hours = !isNotNumber(revenue.sum.result) ? revenue.sum.result : revenue.sum.plan || 0;
                        if (!hours) return acc;

                        const fieldPrize = type === 'first' ? 'firstPrizeRevenue' : 'secondPrizeRevenue';
                        const valuePrize = staff[fieldPrize] || staff.firstPrizeRevenue || 0;
                        if (!valuePrize) return acc;

                        const dataDate = dataRevenues[index];
                        if (isEmpty(dataDate)) return acc;

                        const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;

                        const fieldSum = type === 'first' ? 'firstSumRevenuePrize' : 'secondSumRevenuePrize';
                        const minSum = staff[fieldSum] || staff.firstSumRevenuePrize || 0;
                        if (!revenueDate || revenueDate < minSum) return acc;
                        
                        if (hours >= normalShift) return acc += +valuePrize || 0;
                        return acc += roundToFixed(((+valuePrize || 0) / normalShift) * hours) || 0;
                    }
                    return acc;
                }, 0);
                return result
            }

            if (type === 'sum') {
                const totalRevenues = {
                    first: parseNumToFixed(getRenderTotal(totalHours.first) * (staff.firstRate || 0) + (getPrize('first')) + (getPercent('first') || 0) + (getRevenuePrize('first') || 0)) || 0,
                    second: parseNumToFixed(getRenderTotal(totalHours.second) * (staff.secondRate || staff.firstRate || 0) + getPrize('second') + (getPercent('second') || 0) + (getRevenuePrize('second') || 0)) || 0,
                };
                
                totalRevenues.total = parseNumToFixed((totalRevenues.first || 0) + (totalRevenues.second || 0)) || 0;
    
                total.first += totalRevenues.first;
                total.second += totalRevenues.second;
                total.total += totalRevenues.total;
                return total;
            } else {                
                totalHours.total = parseNumToFixed((getRenderTotal(totalHours.first) || 0) + (getRenderTotal(totalHours.second) || 0)) || 0;
    
                total.first += getRenderTotal(totalHours.first);
                total.second += getRenderTotal(totalHours.second);
                total.total += typeof totalHours.total === 'number' ? totalHours.total : getRenderTotal(totalHours.total);
                return total;
            }            
        }, { first: 0, second: 0, total: 0});
    }

    const getStaffTotalPosts = (staffs, type) => {
        const entityStaffs = (staffs && staffs.length > 0) ? staffs.map((item, index) => ({ ...item, index })) : null;
        if (!entityStaffs || entityStaffs.length === 0) return 0;
        const result = postsIds.reduce((total, post) => {
            const postStaff = entityStaffs.filter((item) => item.postId === post.id && !item.isDelete && !item.isDeleted);
            if (!postStaff || postStaff.length === 0) return total;
            
            const staffTotal = getStaffTotal(postStaff, type);
            if (isEmpty(staffTotal)) return total;

            total.first += +staffTotal.first || 0;
            total.second += +staffTotal.second || 0;
            total.total += +staffTotal.total || 0;
            return total;
        }, { first: 0, second: 0, total: 0});

        return result;
    }

    const getStaffDate = (staffs, index, type) => {
        if (isEmpty(staffs)) return 0;

        return staffs.reduce((total, staff) => {
            if (!staff || (isEmpty(staff.revenues) && isEmpty(staff.prize))) return total;
            if (!isEmpty(staff.revenues) && staff.revenues[index] && !isEmpty(staff.revenues[index].sum)) {
                const revenue = staff.revenues[index].sum;
                if (!isNotNumber(revenue.result)) {
                    total += type === 'hours' ? revenue.result : revenue.result * (index > 14 ? (staff.secondRate || staff.firstRate || 0) : (staff.firstRate || 0));
                } else if (!isNotNumber(revenue.plan)) {
                    total += type === 'hours' ? revenue.plan : revenue.plan * (index > 14 ? (staff.secondRate || staff.firstRate || 0) : (staff.firstRate || 0));;
                }
            }

            if (type !== 'hours') {
                const date = moment(startOfMonthDate).add(index, 'days').format('YYYY-MM-DD');
                if (!isEmpty(staff.prize)) {
                    const prizes = staff.prize.filter((prize) => !prize.isDeleted && prize.date === date);
                    if (!isEmpty(prizes)) prizes.forEach((prize) => {
                        if (prize.type === 'prize') {
                            total += (prize.sum || 0);
                        } else {
                            total -= (prize.sum || 0);
                        }
                    });
                }
                
                const percentSum = getPercentStaff(staff, index, staffs);
                if (percentSum) total += percentSum;

                const prizeRevenueSum = getPrizeRevenueStaff(staff, index);
                if (prizeRevenueSum) total += prizeRevenueSum;
            }
            
            return parseNumToFixed(total);
        }, 0)
    }

    const renderPostValues = (post) => {
        const staff = (staffData && staffData.length > 0) ? [...staffData] : null;
        const postStaff = (staff && staff.length > 0) ? staff.map((item, index) => ({ ...item, index })).filter((item) => item.postId === post.id && !item.isDelete && !item.isDeleted) : null;
        if (isEmpty(postStaff)) return;

        const staffTotalData = getStaffTotal(postStaff, 'sum');
        const revenueCells = (post) => Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;
            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(getStaffDate(postStaff, index) || 0, 0))}
                    </td>
                );
            }
          
            return (
                 <>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(getStaffDate(postStaff, index) || 0, 0))}
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(staffTotalData.first || 0, 0))}
                    </td>
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {`Итого ${post.moreLabel || post.label} руб.`}
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                 </>
            );
        });

        return (
            <tr style={stylesTable.outline} className="kt-datatable__row">
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                    {`Итого ${post.moreLabel || post.label} руб.`}
                </td>
                <td style={stylesTable.sm} className="kt-datatable__cell" />
                {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                }
                {revenueCells(post)}
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {(!period.end.index || period.end.index > 14) ? formatNumberWithSpaces(roundToFixed(staffTotalData.second || 0, 0)) : formatNumberWithSpaces(roundToFixed(staffTotalData.first || 0, 0))}
                </td>
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {formatNumberWithSpaces(roundToFixed(staffTotalData.total || 0, 0))}
                </td>
            </tr>
        );
    }

    const renderValuesTable = () => {
        const staff = (staffData && staffData.length > 0) ? [...staffData] : null;
        const staffTotalData = getStaffTotalPosts(staff, 'sum');
        const revenueCells = () => Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;
            
            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(getStaffDate(staff, index) || 0, 0))}
                    </td>
                );
            }
          
            return (
                 <>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(getStaffDate(staff, index) || 0, 0))}
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(staffTotalData.first || 0, 0))}
                    </td>
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        Итого ФОТ руб.
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                 </>
            );
        });
        return (
            <>
                {postsIds.map((post) => renderPostValues(post))}
                <tr style={stylesTable.outline} className="kt-datatable__row">
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                        Итого ФОТ руб.
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                    {revenueCells()}
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {(!period.end.index || period.end.index > 14) ? formatNumberWithSpaces(roundToFixed(staffTotalData.second || 0, 0)) : formatNumberWithSpaces(roundToFixed(staffTotalData.first || 0, 0))}
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed((staffTotalData.total || 0), 0))}
                    </td>
                </tr>
            </>
        );
    }

    const calculatePercent = (value1, value2) => {
        if (!value1 || !value2) return 0;
        return parseNumToFixed((value1 / value2) * 100);
    }

    const totalData = calculateTotal(dataRevenues, true);

    const renderPostPercent = (post, multiplier) => {
        const staff = (staffData && staffData.length > 0) ? [...staffData] : null;
        const postStaff = (staff && staff.length > 0) ? staff.map((item, index) => ({ ...item, index })).filter((item) => item.postId === post.id && !item.isDelete && !item.isDeleted) : null;
        if (isEmpty(postStaff)) return;
        
        const staffTotalData = getStaffTotal(postStaff, 'sum');
        const revenueCells = (post) => Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((getStaffDate(postStaff, index) || 0), ((getRenderTotal(dataRevenues[index].sum) || 0) * multiplier)))} %
                    </td>
                );
            }
            
            return (
                 <>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((getStaffDate(postStaff, index) || 0), ((getRenderTotal(dataRevenues[index].sum) || 0) * multiplier)))} %
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((staffTotalData.first || 0), (totalData.first.result || totalData.first.plan || 0)))} %
                    </td>
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {`Итого ${post.moreLabel || post.label} %`}
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                 </>
            );
        });

        return (
            <tr style={stylesTable.outline} className="kt-datatable__row">
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                    {`Итого ${post.moreLabel || post.label} %`}
                </td>
                <td style={stylesTable.sm} className="kt-datatable__cell" />
                {openPrizesColumns &&
                <>
                    <td style={stylesTable.md} className="kt-datatable__cell" />
                    <td style={stylesTable.md} className="kt-datatable__cell" />
                </>
                }
                {revenueCells(post)}
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {(!period.end.index || period.end.index > 14) ? formatNumberWithSpaces(calculatePercent((staffTotalData.second || 0), (totalData.second.result || totalData.second.plan || 0))) : formatNumberWithSpaces(calculatePercent((staffTotalData.first || 0), (totalData.first.result || totalData.first.plan || 0)))} %
                </td>
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {formatNumberWithSpaces(calculatePercent((staffTotalData.total || 0), (totalData.total.result || totalData.total.plan || 0)))} %
                </td>
            </tr>
        );
    }

    const renderPercentTable = () => {
        const multiplier = revenueRatio > 0 ? revenueRatio / 100 : 1;
        const staff = (staffData && staffData.length > 0) ? [...staffData] : null;
        const staffTotalData = getStaffTotalPosts(staff, 'sum');
        const revenueCells = () => Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((getStaffDate(staff, index) || 0), ((getRenderTotal(dataRevenues[index].sum) || 0) * multiplier)))} %
                    </td>
                );
            }
          
            return (
                 <>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((getStaffDate(staff, index) || 0), ((getRenderTotal(dataRevenues[index].sum) || 0) * multiplier)))} %
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((staffTotalData.first || 0), (totalData.first.result || totalData.first.plan || 0)))} %
                    </td>
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        Итого ФОТ %
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                 </>
            );
        });

        return (
            <>
                {postsIds.map((post) => renderPostPercent(post, multiplier))}
                <tr style={stylesTable.outline} className="kt-datatable__row">
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                        Итого ФОТ %
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                    {revenueCells()}
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {(!period.end.index || period.end.index > 14) ? formatNumberWithSpaces(calculatePercent((staffTotalData.second || 0), (totalData.second.result || totalData.second.plan || 0))) : formatNumberWithSpaces(calculatePercent((staffTotalData.first || 0), (totalData.first.result || totalData.first.plan || 0)))} %
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent((staffTotalData.total || 0), (totalData.total.result || totalData.total.plan || 0)))} %
                    </td>
                </tr>
            </>
        );
    }

    // const renderPostHours = (post) => {
    //     const staff = (staffData && staffData.length > 0) ? [...staffData] : null;
    //     const postStaff = (staff && staff.length > 0) ? staff.map((item, index) => ({ ...item, index })).filter((item) => item.postId === post.id && !item.isDelete && !item.isDeleted) : null;
    //     if (isEmpty(postStaff)) return;
    // 
    //     const staffTotalData = getStaffTotal(postStaff, 'hours');
    //     const staffRevenueTotal = getStaffTotal(postStaff, 'sum');
        
    //     const revenueCells = (post) => Array.from({ length: columnsCount }, (_, index) => {
    //         if (period.start.index && index < period.start.index) return null;
    //         if (period.end.index && index > period.end.index) return null;

    //         const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

    //         if (index !== 14 || (index === 14 && period.end.index === 14)) {
    //             return (
    //                 <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
    //                     {getStaffDate(postStaff, index, 'hours') || 0}
    //                 </td>
    //             );
    //         }
          
    //         return (
    //              <>
    //                 <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {getStaffDate(postStaff, index, 'hours') || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {parseNumToFixed(staffTotalData.first) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
    //                 <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {`Итого ${post.moreLabel || post.label} часов`}
    //                 </td>
    //                 <td style={stylesTable.sm} className="kt-datatable__cell" />
    //                 {openPrizesColumns &&
    //                 <>
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                 </>
    //                 }
    //              </>
    //         );
    //     });

    //     const revenueCellsInHours = (post) => Array.from({ length: columnsCount }, (_, index) => {
    //         if (period.start.index && index < period.start.index) return null;
    //         if (period.end.index && index > period.end.index) return null;

    //         const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

    //         if (index !== 14 || (index === 14 && period.end.index === 14)) {
    //             return (
    //                 <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
    //                     {parseNumToFixed((getStaffDate(postStaff, index, 'sum') || 0) / (getStaffDate(postStaff, index, 'hours') || 0)) || 0}
    //                 </td>
    //             );
    //         }
          
    //         return (
    //              <>
    //                 <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {parseNumToFixed((getStaffDate(postStaff, index, 'sum') || 0) / (getStaffDate(postStaff, index, 'hours') || 0)) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {parseNumToFixed((staffRevenueTotal.first || 0) / (parseNumToFixed(staffTotalData.first) || 0)) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {`В час ${post.moreLabel || post.label} руб.`}
    //                 </td>
    //                 <td style={stylesTable.sm} className="kt-datatable__cell" />
    //                 {openPrizesColumns &&
    //                 <>
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                 </>
    //                 }
    //              </>
    //         );
    //     });

    //     return (
    //         <>
    //             <tr style={stylesTable.outline} className="kt-datatable__row">
    //                 <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
    //                     {`Итого ${post.moreLabel || post.label} часов`}
    //                 </td>
    //                 <td style={stylesTable.sm} className="kt-datatable__cell" />
    //                 {openPrizesColumns &&
    //                 <>
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                 </>
    //                 }
    //                 {revenueCells(post)}
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {(!period.end.index || period.end.index > 14) ? parseNumToFixed(staffTotalData.second) || 0 : parseNumToFixed(staffTotalData.first) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell"/>
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {parseNumToFixed(staffTotalData.total) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell"/>
    //             </tr>
    //             <tr style={stylesTable.outline} className="kt-datatable__row">
    //                 <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
    //                     {`В час ${post.moreLabel || post.label} руб.`}
    //                 </td>
    //                 <td style={stylesTable.sm} className="kt-datatable__cell" />
    //                 {openPrizesColumns &&
    //                 <>
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                     <td style={stylesTable.md} className="kt-datatable__cell" />
    //                 </>
    //                 }
    //                 {revenueCellsInHours(post)}
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell"/>
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {(!period.end.index || period.end.index > 14) ? parseNumToFixed((staffRevenueTotal.second || 0) / (parseNumToFixed(staffTotalData.second) || 0)) || 0 : parseNumToFixed((staffRevenueTotal.first || 0) / (parseNumToFixed(staffTotalData.first) || 0)) || 0}
    //                 </td>
    //                 <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell"/>
    //                 <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
    //                     {parseNumToFixed((staffRevenueTotal.total || 0) / (parseNumToFixed(staffTotalData.total) || 0)) || 0}
    //                 </td>
    //             </tr>
    //         </>
    //     );
    // }

    // const renderHoursTable = () => {
    //     return (
    //         <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ width: 'max-content', overflow: 'auto' }}>
    //             <table className='kt-datatable__table' style={{ tableLayout: 'fixed', width: '100%' }}>
    //                 <tbody className='kt-datatable__body' style={{ padding: '5px' }}>
    //                     {postsIds.map((post) => renderPostHours(post))}
    //                 </tbody>
    //                 <colgroup>
    //                     {colWidths.map((w, idx) => <col key={idx} style={{ width: w }} />)}
    //                 </colgroup>
    //             </table>
    //         </div>
    //     );
    // }


    const renderSubHeader = () => {
        const revenueCells = () => Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;
            
            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...stylesTable.sm }} className="kt-datatable__cell" />
                );
            }
          
            return (
                 <>
                    <td style={{ ...stylesTable.sm }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button onClick={() => setSelectedTable('sum')} className={selectedTable === 'sum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light'} style={{ padding: '0.2rem 0.5rem'}}>Сумма</button>
                            <button onClick={() => setSelectedTable('percent')} className={selectedTable === 'percent' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light'} style={{ padding: '0.2rem 0.5rem'}}>Проценты</button>
                        </div>
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                    <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                    </>
                    }
                 </>
            );
        });

        return (
            <tr style={{ backgroundColor: '#CCCCCC', ...stylesTable.outline}} className="kt-datatable__row">
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft, overflow: 'visible', position: 'relative' }} className="kt-datatable__cell">
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={() => setSelectedTable('sum')} className={selectedTable === 'sum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light'} style={{ padding: '0.2rem 0.5rem'}}>Сумма</button>
                        <button onClick={() => setSelectedTable('percent')} className={selectedTable === 'percent' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-light'} style={{ padding: '0.2rem 0.5rem'}}>Проценты</button>
                    </div>
                </td>
                <td style={{ ...stylesTable.sm }} className="kt-datatable__cell" />
                {openPrizesColumns && 
                    <>
                    <td style={{ ...stylesTable.md }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.md }} className="kt-datatable__cell" />
                    </>
                }
                {revenueCells()}
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
            </tr>
        );
    
    }
    
    return (
        <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ width: 'max-content', overflow: 'auto' }}>
            <table className='kt-datatable__table' style={{ tableLayout: 'fixed', width: '100%' }}>
                <tbody className='kt-datatable__body' style={{ padding: '5px' }}>
                    {renderSubHeader()}
                    {selectedTable === 'sum' ?
                        renderValuesTable()
                    :
                        renderPercentTable()
                    }
                </tbody>
                <colgroup>
                    {colWidths.map((w, idx) => <col key={idx} style={{ width: w }} />)}
                </colgroup>
            </table>
        </div>
    );
}